import { shopProducts } from '../../mocks/shopData';

export default function ShopPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-50">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-[#2A7A62] to-[#3D9B7F] text-white py-24">
        <div className="absolute inset-0 bg-black/10"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center">
            <h1 className="text-5xl font-bold mb-6">公益商城</h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              购买公益周边，每一笔消费都将转化为爱心捐赠，支持点滴公益
            </p>
          </div>
        </div>
      </section>

      {/* Purchase Notice */}
      <section className="sticky top-20 z-40 bg-gradient-to-r from-[#F4B942] to-[#E8A93C] shadow-lg">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-center gap-4 text-white">
            <i className="ri-information-line text-2xl"></i>
            <p className="text-base font-semibold">
              购买即捐：每件商品销售额的一部分将直接用于点滴公益公益项目
            </p>
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">公益周边商品</h2>
            <p className="text-lg text-gray-600">精选优质商品，传递公益理念</p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
            {shopProducts.map((product) => (
              <div
                key={product.id}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 group"
              >
                <div className="relative aspect-square overflow-hidden bg-gray-100">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 bg-[#E06B3D] text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                    公益商品
                  </div>
                </div>

                <div className="p-5">
                  <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-1">
                    {product.name}
                  </h3>
                  <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                    {product.description}
                  </p>

                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-baseline gap-1">
                      <span className="text-2xl font-bold text-[#2A7A62]">¥{product.price}</span>
                    </div>
                  </div>

                  <div className="bg-gradient-to-r from-[#F4B942]/10 to-[#E8A93C]/10 rounded-lg px-3 py-2 mb-4">
                    <div className="flex items-center gap-2">
                      <i className="ri-heart-fill text-[#E06B3D] text-sm"></i>
                      <span className="text-xs font-semibold text-gray-700">
                        {product.donation}
                      </span>
                    </div>
                  </div>

                  <button className="w-full bg-[#2A7A62] text-white py-3 rounded-lg font-bold hover:bg-[#236B54] transition-colors whitespace-nowrap flex items-center justify-center gap-2">
                    <i className="ri-shopping-cart-line text-lg"></i>
                    <span>立即购买</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Mini Program Section */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="bg-gradient-to-br from-[#2A7A62] via-[#3D9B7F] to-[#2A7A62] rounded-3xl p-12 text-center relative overflow-hidden shadow-2xl">
            <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjA1IiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-30"></div>
            
            <div className="relative z-10">
              <div className="w-24 h-24 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-smartphone-line text-6xl text-white"></i>
              </div>
              
              <h2 className="text-4xl font-bold text-white mb-4">更多商品请访问小程序</h2>
              <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
                扫描下方二维码或点击按钮，前往南山宋窑小程序选购更多公益周边商品
              </p>

              <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-8">
                {/* QR Code - Desktop */}
                <div className="hidden md:block bg-white p-6 rounded-2xl shadow-2xl">
                  <div className="w-48 h-48 bg-gray-100 rounded-xl flex items-center justify-center">
                    <div className="text-center">
                      <i className="ri-qr-code-line text-6xl text-gray-400 mb-2"></i>
                      <p className="text-sm text-gray-500">小程序码</p>
                    </div>
                  </div>
                  <p className="text-center text-sm text-gray-600 mt-4 font-semibold">
                    微信扫一扫
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col gap-4">
                  <button className="bg-white text-[#2A7A62] px-10 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap inline-flex items-center gap-3">
                    <i className="ri-wechat-fill text-2xl"></i>
                    <span>去南山宋窑小程序购买</span>
                  </button>
                  
                  <button className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-10 py-4 rounded-full text-lg font-bold hover:bg-white/20 transition-all duration-300 whitespace-nowrap inline-flex items-center gap-3">
                    <i className="ri-store-line text-2xl"></i>
                    <span>上南山小程序</span>
                  </button>
                </div>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 max-w-2xl mx-auto">
                <div className="flex items-start gap-4 text-left">
                  <i className="ri-information-line text-3xl text-white flex-shrink-0 mt-1"></i>
                  <div className="text-white/90">
                    <p className="font-semibold mb-2">温馨提示：</p>
                    <ul className="space-y-1 text-sm">
                      <li>• 小程序内商品种类更丰富，支持在线支付</li>
                      <li>• 所有商品均为正品，支持7天无理由退换</li>
                      <li>• 购买商品产生的公益金将实时更新到公示页面</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">购买公益商品的意义</h2>
            <p className="text-lg text-gray-600">每一次购买，都是对公益事业的支持</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#2A7A62] to-[#3D9B7F] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-hand-heart-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">支持公益</h3>
              <p className="text-gray-600 leading-relaxed">
                每件商品的部分销售额将直接用于点滴公益，为一线工作者送去关怀
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#F4B942] to-[#E8A93C] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">品质保证</h3>
              <p className="text-gray-600 leading-relaxed">
                所有商品均经过严格筛选，确保质量，让您买得放心用得安心
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg text-center">
              <div className="w-20 h-20 bg-gradient-to-br from-[#E06B3D] to-[#D55A2E] rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-pulse-line text-4xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">传递爱心</h3>
              <p className="text-gray-600 leading-relaxed">
                使用公益周边，向身边人传递公益理念，影响更多人参与公益事业
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}